const multipleRewardsChoicesModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[90%] sm:max-w-[600px] text-black w-[90%] min-w-[300px] px-[10px] py-[20px] sm:px-[20px] overflow-y-auto max-h-[90vh]`,
    closeIconContainer: `absolute top-2 right-2 cursor-pointer`,
    redeem_rewards: `w-full h-auto max-w-[46px]`,
    popupheading: `flex items-center w-full gap-[12px] mb-[15px]`,
    highlightedText: `font-[700] text-primaryHeading`,
    heading: `text-[20px] font-[600] text-themeColor sm:text-[24px]`,
    description: `text-[14px] mb-[20px] text-themeColor sm:text-[16px] text-center`,
    gridContainer: `grid grid-cols-2 md:grid-cols-4 gap-[16px] w-full`,
    optionCard: `flex flex-col items-center justify-center rounded-[8px] cursor-pointer hover:border-themeColor transition-all duration-300 select-none p-0.5 group`,
    optionImage: `!w-full h-auto object-contain max-h-[100px] sm:max-h-[unset] transition-transform duration-300 group-hover:scale-105`,
    optionTitle: `text-[14px] font-[600] text-themeColor text-center`,
    instructionText: `text-[12px] text-gray-500 mt-[5px]`
}

export { multipleRewardsChoicesModalStyles }
